import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistCtx = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setIds([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const { data } = await api.get("/account/wishlist");
      setIds(data.product_ids || []);
    } catch {
      setIds([]);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user !== null) {
      refresh();
    }
  }, [refresh, user]);

  const toggle = async (productId) => {
    const saved = ids.includes(productId);
    const { data } = saved
      ? await api.delete(`/account/wishlist/${productId}`)
      : await api.post(`/account/wishlist/${productId}`);
    setIds(data.product_ids || []);
    return !saved;
  };

  return (
    <WishlistCtx.Provider value={{ ids, isLoading, refresh, toggle }}>
      {children}
    </WishlistCtx.Provider>
  );
}

export const useWishlist = () => useContext(WishlistCtx);